import { useMediaQuery } from '../../../customHooks/useMediaQuery';
import { ReferBanner } from '../referBanner/referBanner';
import { LoadingCard, SellerCard } from './sellerCard';
import { Seller } from './sellerDirectory';

export const Sellers = ({
    sellers,
    filter
}: {
    sellers?: Seller[];
    filter: string | null;
}) => {
    const isMobile = useMediaQuery('(max-width: 624px)');

    const displaySellers =
        filter === null
            ? sellers
            : sellers?.filter((seller) => seller.category === filter);

    return (
        <section>
            {filter ? (
                <h2 className="mb-xs capitalize">{filter} Suppliers</h2>
            ) : (
                <h2 className="mb-xs">Featured iwocaPay Suppliers</h2>
            )}
            <span className="mb-xl block text-s font-reg">
                Select a supplier to open their website.
            </span>
            {isMobile && (
                <div className="mb-l">
                    <ReferBanner />
                </div>
            )}
            <div className="grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-xl">
                {sellers
                    ? displaySellers?.map((seller, i) => (
                          <SellerCard key={i} seller={seller} />
                      ))
                    : Array(9)
                          .fill(null)
                          .map((_, i) => <LoadingCard key={i} />)}
            </div>
        </section>
    );
};
